{
  "version": 1,
  "asset_id": "c12cc5c0-743a-4126-8a14-b2fab2861a11",
  "project_id": "115256dd-a6cc-4bc1-95c1-d787d4c0e481",
  "url": "/__l5e/assets-v1/c12cc5c0-743a-4126-8a14-b2fab2861a11/brand-thetford.png",
  "r2_key": "a/v1/115256dd-a6cc-4bc1-95c1-d787d4c0e481/c12cc5c0-743a-4126-8a14-b2fab2861a11/brand-thetford.png",
  "original_filename": "brand-thetford.png",
  "size": 11785,
  "content_type": "image/png",
  "created_at": "2026-07-14T02:53:50Z"
}
